export function formatCurrency(value: number, compact = false): string {
  if (compact && Math.abs(value) >= 1000) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(value)
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatCurrencyExact(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

export function formatPercent(value: number, decimals = 2): string {
  return `${value.toFixed(decimals)}%`
}

// v0.8.57 — `> 360`, not `>= 360`: the simulation returns Infinity when it
// doesn't converge, so a plan that finishes in exactly month 360 is real.
export function formatMonths(months: number): string {
  if (!isFinite(months) || months > 360) return 'Never (∞)'
  const years = Math.floor(months / 12)
  const remainingMonths = Math.round(months % 12)
  if (years === 0) return `${remainingMonths}mo`
  if (remainingMonths === 0) return `${years}yr`
  return `${years}yr ${remainingMonths}mo`
}

export function formatMonthsLong(months: number): string {
  if (!isFinite(months) || months > 360) return 'Never paid off'
  const years = Math.floor(months / 12)
  const remainingMonths = Math.round(months % 12)
  if (years === 0) return `${remainingMonths} month${remainingMonths !== 1 ? 's' : ''}`
  if (remainingMonths === 0) return `${years} year${years !== 1 ? 's' : ''}`
  return `${years} year${years !== 1 ? 's' : ''}, ${remainingMonths} month${remainingMonths !== 1 ? 's' : ''}`
}

export function formatPayoffDate(months: number, fromDate = new Date()): string {
  if (!isFinite(months) || months > 360) return 'Never'
  // Day-1 anchor: setMonth from the 29th–31st overflowed into the next month.
  const date = new Date(fromDate.getFullYear(), fromDate.getMonth() + Math.round(months), 1)
  return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })
}

export function formatDate(isoDate: string): string {
  return new Date(isoDate).toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  })
}

export function cn(...classes: (string | undefined | false | null)[]): string {
  return classes.filter(Boolean).join(' ')
}
